export default "__VITE_ASSET__xyplU4S7__"